/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_No_Search_Results_DescriptionInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search or filters." |
*
* @param {Project_No_Search_Results_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_no_search_results_description = /** @type {((inputs?: Project_No_Search_Results_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_No_Search_Results_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuchen Sie, Ihre Suche oder Filter anzupassen.")
	return /** @type {LocalizedString} */ ("Try adjusting your search or filters.")
});